import styled, { css } from "styled-components";
import {
  biggerFirstLetter,
  BLACK_BG,
  medium,
  mobileOnly,
  WHITE_BG,
} from "../common/styles/mixins";

export const Artists = styled.div`
  ${mobileOnly(css`
    max-height: 120px;
    overflow: auto;
    margin: -2px;
    padding: 2px;
  `)}
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  > div {
    cursor: pointer;
    margin-bottom: 4px;
    font-size: 0.8em;
    border: 2px solid white;
    padding: 0.3em 1em;
    border-radius: 100px;
    &.selected {
      background-color: ${WHITE_BG};
      color: ${BLACK_BG};
    }
  }
  max-height: 110px;
  overflow: auto;
`;
export const Filters = styled.div`
  ${medium(css`
    width: 300px;
  `)}
  h3 {
    &:first-of-type {
      margin-top: 0;
      font-size: 1.5em;
    }
    &:not(:first-of-type) {
      text-transform: none;
      font-weight: 500;
    }
    margin: 0.5em 0;
  }
  h4 {
    margin: 0;
    font-family: "Bebas Neue Pro Expanded";
    font-size: 1.25em;
  }
  .artist-info {
    width: fit-content;
    padding-bottom: 0.3em;
    margin-bottom: 0.3em;
    cursor: pointer;
    h4 {
      margin-left: 0.3em;
    }
    &:hover {
      > *:first-child {
        transform: scale(1.07);
        transform-origin: center;
      }
    }
  }
`;

export const Artworks = styled.h2`
  display: block;

  ${medium(css`
    display: none;
  `)}
`;

export const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 2em;
  padding: 2px;
  padding-right: 6px;

  ${mobileOnly(css`
    margin-bottom: 2em;
  `)}

  .grid-item {
    width: 100%;
    h2 {
      font-size: 1.25em;
      text-transform: capitalize;
    }
    ${mobileOnly(css`
      &:not(.first) {
        margin-top: 1em;
      }
    `)}
  }

  .art-title {
    margin: 0.25em 0;
  }
  .art-description {
    margin: 0.25em 0;
  }
  .item-content {
    display: flex;
    align-items: space-between;
    height: 100%;
    flex-direction: column;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 1em;
  padding-bottom: 100px;
  min-height: 85hv;
  input {
    width: 100%;
  }
  ${medium(css`
    flex-direction: row;
    margin: 0 2em;
    input {
      width: calc(100% - 18px);
    }
  `)}
  .artist-info {
    display: flex;
    align-items: center;
  }
  .created-by {
    font-size: 0.8em;
    margin-left: 8px;
    * {
      margin: 0;
    }
    span {
      opacity: 0.6;
      font-weight: 300;
      font-size: 0.8em;
    }
    h3 {
      margin-top: -4px;
      ${biggerFirstLetter("1.1em")}
      display: block;
    }
  }
`;
